<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Imagen Mi Proyecto 
              <small>(solo emprendedores):</small>
            </h3>
          </v-col>

          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!my_project_image"
              v-model="my_project_image"
              @change="onProjectImageChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Imagen botón"
              :messages="['Para una mejor visualización, usar un imagen cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="my_project_image"
              wei>
              <v-img
                contain
                :src="url_my_project_image"
                class="grey lighten-2"
                height="440px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteProjectImage()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="4" md="4" sm="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Botón Info
            </h3>
          </v-col>

          <v-col cols="12" class="d-flex justify-center">
            <v-file-input
              outlined
              v-if="!my_project_info_button"
              v-model="my_project_info_button"
              @change="onInfoImageChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Imagen botón"
              :messages="['Para una mejor visualización, usar una imagen máximo de 240x240 px, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="my_project_info_button"
              width="240px">
              <v-img
                fixed
                :src="url_my_project_info_button"
                class="grey lighten-2"
                height="240px"
                width="240px"
                contain
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteInfoImage()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="4" md="4" sm="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Botón Equipo
            </h3>
          </v-col>

          <v-col cols="12" class="d-flex justify-center">
            <v-file-input
              outlined
              v-if="!my_project_up_team_button"
              v-model="my_project_up_team_button"
              @change="onTeamImageChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Imagen botón"
              :messages="['Para una mejor visualización, usar una imagen máximo de 240x240 px, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="my_project_up_team_button"
              width="240px">
              <v-img
                fixed
                :src="url_my_project_up_team_button"
                class="grey lighten-2"
                height="240px"
                width="240px"
                contain
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteTeamImage()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="4" md="4" sm="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Botón Stand
            </h3>
          </v-col>

          <v-col cols="12" class="d-flex justify-center">
            <v-file-input
              outlined
              v-if="!my_project_up_stand_button"
              v-model="my_project_up_stand_button"
              @change="onStandImageChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Imagen botón"
              :messages="['Para una mejor visualización, usar una imagen máximo de 240x240 px, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="my_project_up_stand_button"
              width="240px">
              <v-img
                fixed
                :src="url_my_project_up_stand_button"
                class="grey lighten-2"
                height="240px"
                width="240px"
                contain
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteStandImage()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        :disabled="loading_update"
        color="primary"
        :to="{ name: 'customizationEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateCustomizationEdition()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

     <v-dialog
      v-model="error"
      persistent
      max-width="480"
    >
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>
    
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title 
                v-for="error in errors" 
                v-bind:key="error"
                style="white-space: normal; word-break: break-word;"
                class="pt-2">
                - {{ error }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'customizationMyProject',
    data: () => ({
      loading:true,
      loading_update: false,
      edition_id:null,
      customization:[],

      my_project_image: null,
      url_my_project_image: null,

      my_project_info_button: null,
      url_my_project_info_button: null,

      my_project_up_team_button:null,
      url_my_project_up_team_button:null,

      my_project_up_stand_button: null,
      url_my_project_up_stand_button: null,

      error:false,
      errors:[],
    }),

    methods:{
      async getCustomization(){
        await axios.get('admin/editions/'+this.edition_id+'/customization').then(response =>{
          this.customization = response.data.data.customization

          this.my_project_image = response.data.data.customization.my_project_image
          this.url_my_project_image = APP_URL+ this.my_project_image

          this.my_project_info_button = response.data.data.customization.my_project_info_button
          this.url_my_project_info_button = APP_URL+ this.my_project_info_button

          this.my_project_up_team_button = response.data.data.customization.my_project_up_team_button
          this.url_my_project_up_team_button = APP_URL+ this.my_project_up_team_button

          this.my_project_up_stand_button = response.data.data.customization.my_project_up_stand_button
          this.url_my_project_up_stand_button = APP_URL+ this.my_project_up_stand_button

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateCustomizationEdition(){
        this.loading_update=true
        let formData= new FormData()
        formData.append('my_project_image', this.my_project_image)
        formData.append('my_project_info_button', this.my_project_info_button)
        formData.append('my_project_up_team_button', this.my_project_up_team_button)
        formData.append('my_project_up_stand_button', this.my_project_up_stand_button)

        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/customization-my-project',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
          this.loading_update=false
          this.error = true
          this.errors = Object.values(error.response.data.errors).flat()
        }
      },

      //-------My Project-----------
      onProjectImageChange() {
        this.url_my_project_image = URL.createObjectURL(this.my_project_image);
      },

      deleteProjectImage(){
        this.my_project_image=null
        this.url_my_project_image=null
      },

      //-------info button-----------
      onInfoImageChange() {
        this.url_my_project_info_button = URL.createObjectURL(this.my_project_info_button);
      },

      deleteInfoImage(){
        this.my_project_info_button=null
        this.url_my_project_info_button=null
      },

      //-------Team button-----------
      onTeamImageChange() {
        this.url_my_project_up_team_button = URL.createObjectURL(this.my_project_up_team_button);
      },

      deleteTeamImage(){
        this.my_project_up_team_button=null
        this.url_my_project_up_team_button=null
      },

      //-------window button-----------
      onStandImageChange() {
        this.url_my_project_up_stand_button = URL.createObjectURL(this.my_project_up_stand_button);
      },

      deleteStandImage(){
        this.my_project_up_stand_button=null
        this.url_my_project_up_stand_button=null
      }

    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getCustomization()
    },
  }
</script>
